import { RmaLrpCommodityCodes, RmaLrpTypeCodes } from '@harvestiq/constants';
import { z, zCalendarDate } from '@harvestiq/zod';
import { zIsoDate } from '@harvestiq/zod';

export const salesEffectiveDatesRequestSchema = z.object({
  limit: z.number().optional(),
});

export type SalesEffectiveDatesRequest = z.infer<
  typeof salesEffectiveDatesRequestSchema
>;

export const salesEffectiveDatesResponseSchema = z.object({
  data: zIsoDate().array(),
});

export type SalesEffectiveDatesResponse = z.infer<
  typeof salesEffectiveDatesResponseSchema
>;

export const getLrpSalesEffectiveDatesParamsSchema = z.object({
  limit: z.coerce.number().optional(),
  startDate: zCalendarDate()
    .optional()
    .openapi({
      example: '2025-01-01',
    })
    .describe(
      'Filter to sales effective dates on or after this date (YYYY-MM-DD).'
    ),
  finalDate: zCalendarDate()
    .optional()
    .openapi({
      example: '2025-12-31',
    })
    .describe(
      'Filter to sales effective dates on or before this date (YYYY-MM-DD).'
    ),
  commodityCode: z.nativeEnum(RmaLrpCommodityCodes).optional(),
  typeCode: z.nativeEnum(RmaLrpTypeCodes).optional(),
});
export type GetLrpSalesEffectiveDatesParams = z.infer<
  typeof getLrpSalesEffectiveDatesParamsSchema
>;

export const getLrpSalesEffectiveDatesResponseSchema = z
  .object({
    salesEffectiveDates: zIsoDate().array(),
  })
  .openapi({
    example: {
      salesEffectiveDates: ['2024-12-30', '2024-12-29', '2024-12-28'],
    },
  });

export type GetLrpSalesEffectiveDatesResponse = z.infer<
  typeof getLrpSalesEffectiveDatesResponseSchema
>;
